module.exports = __webpack_public_path__ + "static/2-285fe1dcfe95131efdebb397c676a1d7.png";